import React from "react";
import { UserbackFormButton } from "@/components/parts/UserbackFormButton";

export const FeedbackNote: React.FC = () => {
  return (
    <p className="mx-auto mt-5 max-w-2xl text-center text-xs text-primary-800">
      ※「こんなことが知りたい」「ここが使いにくい」など、ひとことだけでも歓迎です。
      <span className="ml-1 inline-block">
        <UserbackFormButton
          label="ひとこと送る"
          feedbackType="feature_request"
          className="hover:text-primary-600"
        />
      </span>
    </p>
  );
};

export const FeedbackInvitation: React.FC = () => {
  return (
    <p className="mx-auto max-w-2xl text-center text-sm leading-relaxed text-text">
      猫との暮らしで、こまっていることはありませんか。
      <br />
      「これが調べられたらいいのに」と思うことを教えてください。
      <span className="ml-2 inline-block">
        <UserbackFormButton
          label="こまりごとを送る →"
          feedbackType="feature_request"
          className="font-medium text-primary-600 hover:text-primary-700 active:text-secondary-500"
        />
      </span>
    </p>
  );
};
